var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSomalia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C31.0459 40.0001 40.0002 31.0458 40.0002 20.0001C40.0002 8.95443 31.0459 0.000123978 20.0002 0.000123978C8.95452 0.000123978 0.000213623 8.95443 0.000213623 20.0001C0.000213623 31.0458 8.95452 40.0001 20.0002 40.0001Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.4348L22.1584 17.0777H29.1431L23.4923 21.1832L25.6508 27.8261L20 23.7206L14.3492 27.8261L16.5076 21.1832L10.8568 17.0777H17.8415L20 10.4348Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomalia);
export default __webpack_public_path__ + "static/media/somalia.8a834d8a4ec27ab2dc7760491fad002c.svg";
export { ForwardRef as ReactComponent };